<template>
  <score-main @back="goBack">
    <template slot="nav">
      <div class="scoreNav">
        <p>
          {{classInfo.class_name}}
        </p>
      </div>
    </template>
    <template slot="main">
      <div class="scoreMain">
        <div class="content">
          <div v-if="showList" class="scrollArea">
            <vue-scroll :ops="ops">
              <template v-if="classInfo.class_train_type === 'continue_education' && classInfo.examine_way.includes('200')">
                <div class="five-tips">
                  <span class="tips-item">评分标准：教案考核为“差”则为继续教育未通过（如学员未提交考核教案，系统默认成绩为“差”，继续教育未通过），其他教案考核评级均为继续教育通过。</span>
                </div>
              </template>
              <div class="table">
                <div v-for="(item, index) in formVal" :class="{
                  item:true,
                  exam_border:item.border,
                  repetition_stu: (item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0) || (item.is_fail && classInfo.class_train_type === 'continue_education'),
                  item_border:!(item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0) && !(item.is_fail && classInfo.class_train_type === 'continue_education')}"
                  :title="item.student_information | tipMsg(classInfo.is_restrict_stu_info,item.notNotes)">
                  <!--<div v-if="item.border" class="exam_stu" >-->
                    <!--<div class="dash_line "></div>-->
                    <!--<div class="dash_content">补考人员</div>-->
                    <!--<div class="dash_line"></div>-->
                  <!--</div>-->
                  <div class="row up">
                    <div class="col user">
                      <div class="num" >{{ index +1 }}</div>
<!--                      <div class="num" v-if="item.enroll_type==='common'">{{index+1}}</div>-->
<!--                      <div class="num" v-else>{{ examObj[index] }}</div>-->
                      <img :src="item.user_img||User" alt="" @error="userImgError(index)" @click="viewDetail(item.uid)">
                      <div class="wrap">
                        <p class="name">{{item.user_name}}</p>
                        <!--<div class="btn" @click="lookTutorial(item.user_id)">查看教案</div>-->
                        <template v-if="classInfo.class_train_type === 'continue_education' && classInfo.examine_way.includes('200')">

                          <template v-if="item.plan_id">
                            <router-link class="btn" target="_blank" :to="{path: 'tutorial_detail', query: {id: item.plan_id}}">
                              查看教案
                            </router-link>
                          </template>
                          <template v-else>
                            <div  class="nonePlan">
                              无考试教案
                            </div>
                          </template>
                        </template>
                        <template v-else>
                          <router-link class="btn" target="_blank" :to="{path: 'stu_tutorial', query: {user_id: item.uid, c_id: c_id, home: true}}">
                            查看教案
                          </router-link>
                        </template>
                      </div>
                    </div>
                    <div class="col info">
                      <div class="title">
                        <p>基</p>
                        <p>本</p>
                        <p>信</p>
                        <p>息</p>
                      </div>
                      <div class="block">
                        <div class="line">
                          <p>证件号：{{item.id_number}}</p>
                        </div>
                        <div class="line">
                          <p>
                            <span>性别 : {{item.gender|getGender}}</span>
                            <span>手机 : {{item.mobile_phone}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col note">
                      <div class="title">
                        <!-- <template v-if="isFive">
                          <p>综</p>
                          <p>合</p>
                          <p>评</p>
                          <p>价</p>
                        </template>
                        <template v-else> -->
                          <p>备</p>
                          <p>注</p>
                        <!-- </template> -->

                      </div>
                      <textarea v-model="item.remark" :placeholder="note" :disabled="(item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0) || (item.is_fail === 1 && classInfo.class_train_type === 'continue_education')"></textarea>
                    </div>
                    <div class="col average" v-if="item.enroll_type==='common'">
                      <div class="title">
                        <p>综合</p>
                        <p>平均</p>
                        <p>成绩</p>
                      </div>
                      <div class="score">
                        <p>{{item.practice_avg_points || '--'}}</p>
                      </div>
                    </div>
                    <div class="col grade">
                      <div class="title">
                        <p>成</p>
                        <p>绩</p>
                      </div>
                      <div class="score" v-if="item.scoreArr.length === 0">
                        <div :class="item.results_status == 'pass' ? 'blue-theam' : 'red-theam'">
                          <el-radio
                            v-model="item.results_status"
                            label="pass"
                            class="scoreResult"
                            @change="getResult()">
                            通过
                          </el-radio>
                          <el-radio
                            v-model="item.results_status"
                            label="fail" class="scoreResult"
                            style="margin-top:15px" @change="getResult()">
                            未通过
                          </el-radio>
                        </div>
                      </div>
                      <div class="score" style="text-align: center;" v-else>
                        <p :class="{
                        'pass': item.results_status === 'pass',
                        'fail': (item.results_status === 'fail') || (item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0)
                        }">
                            <span v-if="item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0">
                              {{'fail' | showScore}}
                            </span>
                          <span v-else>
                              {{item.results_status|showScore}}
                            </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row down" v-if="item.scoreArr.length > 0">
                    <div class="col" v-for="(col, colIndex) in item.scoreArr" :key="colIndex">
                      <span>{{col.achievement_subject_des}}</span>
                      <score-input :val.sync="col.achievement_score"
                        :title.sync="col.achievement_subject_des"
                        :subject_id.sync="col.achievement_subject_id"
                        :err.sync="col.err"
                        :type="item.enroll_type"
                        :disabled_status="(item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0) || (item.is_fail === 1 && classInfo.class_train_type === 'continue_education')"
                        @change="getScoreEducation(index)"></score-input>
                    </div>
                  </div>
                </div>
                <el-row v-if="showTotal" class="score-result">
                  <el-col :span="8" class="result-col">学员人数：{{formVal.length}}</el-col>
                  <el-col :span="8" class="result-col">通过：{{passNum}}</el-col>
                  <el-col :span="8" class="result-col">未通过：{{formVal.length-passNum}}</el-col>
                </el-row>
              </div>
            </vue-scroll>
          </div>
        </div>
        <div class="btns">
          <div class="btn success"
               @click="previewScore">预览</div>
          <div class="btn success"
            @click="tempUpload">{{role_type === 'teacher' ? '暂时保存' : '保存' }}</div>
          <div class="btn success"
            @click="nextStepEducation">下一步(<span>培训班报告</span>)</div>
          <!--<div class="btn success"-->
               <!--@click="submitUploadEducation" v-if="(classInfo.status === 'Finalised' || classInfo.status === 'ScoreRefused') && role_type === 'teacher' ">提交</div>-->
          <div class="btn error"
               @click="goBack">取消</div>
        </div>
        <yioks-tips :tips="backWarn.tips"
                    :showTips="backWarn.flag"
                    @hideTips="hideBackTips"></yioks-tips>
        <yioks-tips :tips="uploadWarn.tips"
                    :showTips="uploadWarn.flag"
                    :loading="loading"
                    @hideTips="hideUploadTips"></yioks-tips>
        <yioks-tips :tips="nextWarn.tips"
                    :showTips="nextWarn.flag"
                    :loading="loading"
                    @hideTips="hideNextTips"></yioks-tips>
        <yioks-tips :tips="submitUploadEducationWarn.tips"
          :showTips="submitUploadEducationWarn.flag"
          :loading="loading"
          @hideTips="hideSubmitUploadEducationTips"></yioks-tips>
        <el-dialog
            class="detail-info-dia preview-score"
            title="成绩预览"
            :visible.sync="showPreScore"
            :close-on-click-modal="false"
            width="900px"
            top="10vh"
        >
          <div class="scroll-wrap">
            <vue-scroll :ops="disScrollOpt" ref="vScroll">
              <div class="table">
                <div v-for="(item, index) in formVal" class="item"
                :class="{
                exam_border:item.border,
                }">
                  <!--<div v-if="item.border" class="exam_stu " >-->
                    <!--<div class="dash_line black_boder"></div>-->
                    <!--<div class="dash_content">补考人员</div>-->
                    <!--<div class="dash_line black_boder"></div>-->
                  <!--</div>-->
                  <!--<el-row v-if="showTotal && item.showTotal && (classInfo.class_level==='B'|| classInfo.class_level==='A' ) "-->
                          <!--class="score-result totalCommonStu" :class="item.border ? null :'nolineTotal'">-->
                    <!--<el-col :span="6" class="result-col">学员人数：{{commonStuList.length}}</el-col>-->
                    <!--<el-col :span="6" class="result-col">通过：{{passNum}}</el-col>-->
                    <!--<el-col :span="6" class="result-col">未通过：{{fail}}</el-col>-->
                    <!--<el-col :span="6" class="result-col">实践课补考：{{commonStuList.length- passNum - fail}}</el-col>-->
                  <!--</el-row>-->
                  <div class="row up">
                    <div class="col user">
                      <div class="num">{{ index +1 }}</div>
                      <img :src="item.user_img||User" alt="" @error="userImgError(index)">
                      <div class="wrap">
                        <p class="name">{{item.user_name}}</p>
                      </div>
                    </div>
                    <div class="col info">
                      <div class="title">
                        <p>基</p>
                        <p>本</p>
                        <p>信</p>
                        <p>息</p>
                      </div>
                      <div class="block">
                        <div class="line">
                          <p>证件号 : {{item.id_number}}</p>
                        </div>
                        <div class="line">
                          <p>
                            <span>性别 : {{item.gender|getGender}}</span>
                            <span>手机 : {{item.mobile_phone}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col note">
                      <div class="title">
                        <!-- <template v-if="isFive">
                          <p>综</p>
                          <p>合</p>
                          <p>评</p>
                          <p>价</p>
                        </template>
                        <template v-else> -->
                          <p>备</p>
                          <p>注</p>
                        <!-- </template> -->
                      </div>
                      <textarea v-model="item.remark || '暂无备注'"
                                :disabled="true"></textarea>
                    </div>
                    <div class="col grade">
                      <div class="title">
                        <p>成</p>
                        <p>绩</p>
                      </div>
                      <div class="score">
                        <p :class="{
                        'pass': item.results_status === 'pass',
                        'fail': (item.results_status === 'fail') || (item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0)
                        }">
                          <span v-if="item.student_information === 'verify' && classInfo.is_restrict_stu_info === 0">
                            未通过
                            </span>
                          <span v-else>
                              {{item.results_status|showScore}}
                            </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                  <el-row v-if="showTotal"
                          class="score-result">
                    <el-col :span="8" class="result-col">学员人数：{{formVal.length}}</el-col>
                    <el-col :span="8" class="result-col">通过：{{passNum}}</el-col>
                    <el-col :span="8" class="result-col">未通过：{{formVal.length-passNum}}</el-col>
                  </el-row>
              </div>
            </vue-scroll>
          </div>
        </el-dialog>
        <el-dialog
            class="detail-info-dia stu-info"
            title="详细信息"
            :visible.sync="ifDiaShow"
            :close-on-click-modal="false"
            width="750px"
            top="12vh"
        >
          <div class="scroll-wrap">
            <vue-scroll :ops="disScrollOpt" ref="vScroll">
              <div class="stu-info-box">
                <stu-detail-info :uid='stuUid'
                                 :cid="c_id"></stu-detail-info>
              </div>
            </vue-scroll>
          </div>
        </el-dialog>
      </div>
    </template>
  </score-main>
</template>

<script>
  import scoreMixin from "@/minix/score";

  export default {
    name: "upload-score-edcation",
    mixins: [scoreMixin],
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  @import '~@/assets/css/mixin';

  .scoreNav {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    font-size: $font_size_big;
  }
  .scoreMain {
    width: 100%;
    height: 100%;
    .content {
      height: 92%;
      box-sizing: border-box;
      padding: 15px 0 15px 20px;
      background-color: $block_bg_color_base;
      .five-tips {
        color: $color_unusual
        &:last-child {
          margin-bottom 20px
        }
        .tips-item {
          margin-right: 10px
          &:last-child {
            margin-right: 0px
          }
        }
      }
      .scrollArea {
        width: 100%;
        height: 100%;
        .table {
          padding: 0 20px 20px 0;
          .item {
            margin: 0 0 20px 0;
            .row {
              display: flex;
              position: relative;
              .col {
                flex: 1 1 auto;
                border-right: 1px solid $color_white;
                &:last-child {
                  border-right: none;
                }
              }
              &.up {
                // height: 80px;
                .col {
                  // height: 100%;
                  &.user {
                    width: 25%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    padding-left:8px;
                    .num {
                      position: absolute;
                      top: 3px;
                      left: 5px;
                    }
                    img {
                      flex: 0 0 auto;
                      width: 60px;
                      height: 60px;
                      border-radius: 50%;
                      cursor: pointer;
                    }
                    .wrap {
                      // height: 100%;
                      margin: 0 0 0 12px;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-around;
                      align-items: center;
                      width 100%
                      .name {
                        font-size: $font_size_medium;
                        // word-break break-word
                        word-break break-all
                        word-wrap break-word
                        margin-bottom 5px
                        width 100%
                        text-align center
                      }
                      .btn {
                        padding: 5px 15px;
                        background-color: $color_suc;
                        border-radius: 5px;
                        cursor: pointer;
                        user-select: none;
                      }
                      .nonePlan{
                        padding: 5px 15px;
                        background-color: $color_background_grey;
                        border-radius: 5px;
                        cursor: not-allowed;
                        user-select: none;
                      }
                    }
                  }
                  title() {
                    flex: 0 0 auto;
                    width: 30px;
                    // height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid $color_white;
                  }
                  &.info {
                    width: 33%;
                    display: flex;
                    .title {
                      title();
                    }
                    .block {
                      flex: 1 1 auto;
                      display: flex;
                      flex-direction: column;
                      .line {
                        flex: 1 1 auto;
                        /*padding: 0 0 0 20px;*/
                        /*padding: 0 0 0 2px;*/
                        display: flex;
                        align-items: center;
                        font-size: $font_size_base;
                        border-bottom: 1px solid $color_white;
                        &:last-child {
                          border-bottom: none;
                        }
                        span:first-child {
                          margin: 0 5px 0 0;
                        }
                      }
                    }
                  }
                  &.note {
                    width: 25%;
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                      align-self stretch
                    }
                    textarea {
                      flex: 1 1 auto;
                      margin: 0 10px;
                      color: $color_black;
                      border-radius: 5px;
                      outline: none;
                      resize: none;
                    }
                  }
                  &.average{
                    width 15%
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                      width 45px
                    }
                    .score {
                      flex: 1 1 auto;
                      text-align: center;
                    }
                  }
                  &.grade {
                    width: 17%;
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                      align-self stretch
                    }
                    .score {
                      flex: 1 1 auto;
                      font-size: $font_size_medium;
                      .pass {
                        color: $color_suc;
                      }
                      .fail {
                        color: $color_err;
                      }
                      .scoreResult{
                        margin-left :15px;
                        color:#FFFFFF
                      }
                    }
                  }
                }
              }
              &.down {
                .col {
                  width: 25%;
                  padding: 10px 0 0;
                  display: flex;
                  flex-direction: column;
                  align-items center;
                  border-top: 1px solid #FFFFFF;
                  .total {
                    margin: 10px 0;
                  }
                }
              }
            }
            .nolineTotal{
              position absolute
              display flex
              align-items center
              justify-content: center;
              width: 100%;
              bottom: -60px;
            }
          }
          .score-result {
            border: 1px solid $color_white;
            .result-col {
              padding: 10px 0 10px 10px;
              border-right: 1px solid $color_white;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
      }
    }
    .btns {
      height: 40px;
      margin: 10px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        height: 100%;
        margin: 0 20px;
        padding: 8px 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        line-height: $font_size_medium;
        border-radius: 5px;
        cursor: pointer;
        user-select: none;
      }
      .success {
        background-color: $color_suc;
      }
      .error {
        background-color: $color_err;
      }
    }
    .preview-score {
      /*.score-row {
        border: 1px solid $color_black;
        .score-col {
          text-align: center;
          font-size: $font_size_big;
          border-right: 1px solid $color_black;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &:last-child {
            border-right: none;
          }
        }
      }
      .score-head {
        padding: 0 15px;
        .score-row {
          .score-col {
            padding: 5px 0;
            font-weight: bolder;
          }
        }
      }
      .score-body {
        padding: 0 15px;
        .score-row {
          border-top: none;
          &:nth-child(even) {
            background-color: $color_text_placeholder;
          }
        }
      }*/
      .scroll-wrap {
        display: block;
        height: 630px;
        overflow: hidden;
        position: relative;
        .table {
          padding: 0 20px 20px 0;
          .item {
            margin: 0 0 20px 0;
            border: 1px solid $color_black;
            position relative
            .row {
              display: flex;
              .col {
                flex: 1 1 auto;
                border-right: 1px solid $color_black;
                &:last-child {
                  border-right: none;
                }
              }
              &.up {
                height: 80px;
                .col {
                  height: 100%;
                  &.user {
                    width: 25%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    padding-left:8px;
                    .num {
                      position: absolute;
                      top: 3px;
                      left: 5px;
                    }
                    img {
                      flex: 0 0 auto;
                      width: 60px;
                      height: 60px;
                      border-radius: 50%;
                    }
                    .wrap {
                      height: 100%;
                      margin: 0 0 0 20px;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-around;
                      align-items: center;
                      width 100%
                      .name {
                        font-size: $font_size_medium;
                        width:100%;
                        text-align:center;
                      }
                      .btn {
                        padding: 5px 15px;
                        background-color: $color_suc;
                        border-radius: 5px;
                        cursor: pointer;
                        user-select: none;
                      }
                    }
                  }
                  title() {
                    flex: 0 0 auto;
                    width: 30px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid $color_black;
                  }
                  &.info {
                    width: 33%;
                    display: flex;
                    .title {
                      title();
                    }
                    .block {
                      flex: 1 1 auto;
                      display: flex;
                      flex-direction: column;
                      .line {
                        flex: 1 1 auto;
                        /*padding: 0 0 0 20px;*/
                        /*padding: 0 0 0 2px;*/
                        display: flex;
                        align-items: center;
                        font-size: $font_size_base;
                        border-bottom: 1px solid $color_black;
                        &:last-child {
                          border-bottom: none;
                        }
                        span:first-child {
                          margin: 0 5px 0 0;
                        }
                      }
                    }
                  }
                  &.note {
                    width: 25%;
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                    }
                    textarea {
                      flex: 1 1 auto;
                      margin: 0 10px;
                      border-radius: 5px;
                      outline: none;
                      resize: none;
                    }
                  }
                  &.average{
                    width 15%
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                      width 45px
                    }
                    .score {
                      flex: 1 1 auto;
                      text-align: center;
                    }
                  }
                  &.grade {
                    width: 17%;
                    display: flex;
                    align-items: center;
                    .title {
                      title();
                    }
                    .score {
                      flex: 1 1 auto;
                      text-align: center;
                      font-size: $font_size_medium;
                      .pass {
                        color: $color_suc;
                      }
                      .fail {
                        color: $color_err;
                      }
                    }
                  }
                }
              }
              &.down {
                .col {
                  width: 25%;
                  padding: 5px 0 0;
                  display: flex;
                  flex-direction: column;
                  align-items center;
                  .total {
                    margin: 10px 0;
                  }
                }
              }
            }
            .nolineTotal{
              position absolute
              display flex
              align-items center
              justify-content: center;
              width: 100%;
              bottom: -60px;
            }
          }
          .score-result {
            border: 1px solid $color_black;
            .result-col {
              padding: 10px 0 10px 10px;
              border-right: 1px solid $color_black;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
      }
    }
    .stu-info {
      .scroll-wrap {
        display: block;
        height: 530px;
        overflow: hidden;
        position: relative;
        .stu-info-box {
          display: block;
          padding: 0 15px;
          font-size: $font_size_medium;
        }
      }
    }
    .repetition_stu {
      border: 1px solid $color_err;
    }
    .item_border{
      border: 1px solid $color_white;
      position relative
    }
    .exam_border{
      margin-top 100px !important
      position relative
      .exam_stu{
        position absolute
        width 100%
        top: -30px
        display flex
        align-items center
        .dash_line{
          width 45%
          height 0
          border 1px dashed $color_white
        }
        .black_boder{
          border 1px dashed $color_black
        }
        .dash_content{
          font-size 18px
          text-align center
          width 10%
        }
      }
      .totalCommonStu{
        position: absolute;
        width: 100%;
        top: -84px;
        display: flex;
        align-items: center;
      }
  }
  }
</style>

<style lang="stylus">

  .red-theam
    /*.el-radio__input */
    .is-checked
      .el-radio__inner
        border-color #ff0000
        background #ff0000
      .el-radio__label
        color #ff0000

  .blue-theam
    .is-checked
      .el-radio__inner
        border-color #4cd964
        background #4cd964
      .el-radio__label
        color #4cd964
</style>
